import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResources41_1bTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResources41_1b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_MATERIALS_USE") || "Surplus materials generated from use of the product"}
        subDescription={t("SURPLUS_MATERIALS_USE_41_1B_DESC") || "Here, we list materials that are required for usage but do not form part of the final product. These materials become surplus resources. Select one of the options below to indicate how they are treated."}
        isNormal={true}
        number={"41.1b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-41-1b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResources41_1bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResources41_1b;


